let adminBase = window._env_.VUE_APP_ADMIN_HOST
let baseHost = window._env_.VUE_APP_HOST

// 平台用户
export const getPlatformUsersIndex = params => {
  return axios.post(`${adminBase}/adminuser/query`, params)
}
export const getBasicPlatformUsersIndex = params => {
  return axios.post(`${adminBase}/basic-info/query_adminuser`, params)
}
export const getPlatformUsersDetail = params => {
  if (params && params.host) {
    return axios.get(`//${params.host}/adminuser/get_${params.id}`)
  }
  return axios.get(`${adminBase}/adminuser/get_${params.id}`)
}
export const addPlatformUser = params => {
  if (params && params.host) {
    return axios.post(`//${params.host}/admin/adminuser/create`, params)
  }
  return axios.post(`${adminBase}/adminuser/create`, params)
}
export const editPlatformUser = params => {
  if (params && params.host) {
    return axios.post(`//${params.host}/admin/adminuser/edit_${params.id}`, params)
  }
  return axios.post(`${adminBase}/adminuser/edit_${params.id}`, params)
}
export const deletePlatformUser = id => {
  return axios.post(`${adminBase}/adminuser/delete_${id}`)
}
export const copyPlatformUser = id => {
  return axios.post(`${adminBase}/adminuser/copy_${id}`)
}

export const getUserPermissionsAndRoles = params => {
  return axios.get(`//${params.host}/permissions/user/get_${params.id}`)
}
export const editUserPermissionsAndRoles = params => {
  return axios.post(`//${params.host}/permissions/user/edit_${params.id}`, params)
}



// 其它设置选项
export const getAllDepartments = params => {
  return axios.get(`${adminBase}/department/list`)
}
export const getAllCustomers = params => {
  if (params && params.host) {
    return axios.get(`//${params.host}/admin/customer/list`)
  }
  return axios.get(`${adminBase}/customer/list`)
}
export const getAdminOptions = params => {
  return axios.get(`${adminBase}/adminuser/optionlist`)
}

// 批量分配客户
export const AllotPlatformUserMany = params => {
  return axios.post(`${adminBase}/adminuser/batch_assgin_customers`, params)
}
export const findPermissions = (route) => {
  return axios.get(`${adminBase}/permission_${route}`)
}
export const updatePermissions = ({route, data}) => {
  return axios.post(`${adminBase}/permission_${route}`, data)
}

// 审计日志
export const AuditLogTableApi = params => {
  return axios.post(`${baseHost}/oplogs/list`, params)
}

// 批量分配管理员角色
export const batchSetAdminRoles = params => {
  if (params && params.host) {
    return axios.post(`//${params.host}/permissions/user/add_roles_${params.admin_id}`, params)
  }
  return axios.post(`${adminBase}/permissions/user/add_roles_${params.admin_id}`, params)
}
export const batchSetAdminUIRoles = params => {
  return axios.post(`${adminBase}/uipermission/user/add_roles_${params.admin_id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/platform-user/platform-user.api.js